/* eslint-disable @typescript-eslint/ban-ts-comment */
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { BankResetItems, IBankItem } from "web/types/Banks";

import type { TBankCountsForPaymentSortContext } from "./getBankCountForPaymentSortContext";
import getBankMappedWithBalances from "./getBankMappedWithBalances";
import getProductsPaymentSettingsData from "./getProductsPaymentSettingsData";
import getProductsPaymentSettingsDataWithFormattedValue from "./getProductsPaymentSettingsDataWithFormattedValue";
import getProductsSeparatedWithTypes from "./getProductsSeparatedWithTypes";
import getProductsToSeparateAutomatically from "./getProductsToSeparateAutomatically";
import getProductsWithActivePaymentSettings from "./getProductsWithActivePaymentSettings";
import { ProductToSeparate, SeparatedProduct } from "./types";

interface SeparateFinancingSourcesPerProductProps {
  products: ProductToSeparate[];
  banks: IBankItem[];
  name: string;
  separated: SeparatedProduct[];
  bankCountsForPaymentSortContext: TBankCountsForPaymentSortContext;
  bankResets: BankResetItems;
}

const separateFinancingSourcesPerProduct = ({
  products,
  banks,
  name,
  separated,
  bankCountsForPaymentSortContext,
  bankResets,
}: SeparateFinancingSourcesPerProductProps) => {
  if (!isArrayHasItems(products)) {
    return [];
  }

  const productsWithActivePaymentSettings =
    getProductsWithActivePaymentSettings(products, banks);

  const productsSeparatedWithTypes = getProductsSeparatedWithTypes(
    products,
    separated
  );

  const productsToSeparateAutomatically = getProductsToSeparateAutomatically(
    productsSeparatedWithTypes,
    productsWithActivePaymentSettings
  );

  const bankMappedWithBalances = getBankMappedWithBalances(
    banks,
    productsSeparatedWithTypes
  );

  const productsPaymentSettingsData = getProductsPaymentSettingsData(
    productsToSeparateAutomatically,
    bankMappedWithBalances,
    name,
    bankCountsForPaymentSortContext,
    bankResets
  );

  // @ts-ignore
  return getProductsPaymentSettingsDataWithFormattedValue([
    ...productsPaymentSettingsData.items,
    ...productsSeparatedWithTypes,
  ]) as {
    sku: string;
    payment_settings: {
      code: string;
      value: number;
      type: string;
    }[];
  }[];
};

export default separateFinancingSourcesPerProduct;
